// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgEnvelopeIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm.275 3.489 6.408 6a1.954 1.954 0 0 0 2.634 0l6.408-6c.587-.55.171-1.489-.658-1.489H4.933c-.83 0-1.245.94-.658 1.489"
    />
  </g>
);
export default SvgEnvelopeIcon;
SvgEnvelopeIcon.displayName = 'SvgEnvelopeIcon';
